<template>
  <div>
    <GridTable
      ref="gridTable"
      id="StudentSubjectList"
      :hasTitle="false"
      urlPath="lessonsCms"
      :columns="columns"
      :schema="schema"
      :supportAddNew="false"
      :hasEditItem="false"
      :hasDeleteItem="false"
      :defaultServerParams="defaultServerParams"
    >
      <template v-slot:customButtons="slotProps">
        <!-- <router-link :to="{ name: 'StudentDetail', params: { id: slotProps.props.row._id }}" class="btn btn-success">View</router-link> -->
        <ModalComponent
          :id="slotProps.props.row.originalIndex"
          width="400"
          :component="modalLessonDetail(slotProps.props.row)"
        >
          View
        </ModalComponent>
      </template>
    </GridTable>
  </div>
</template>

<script>
import { Component, Prop, Watch } from 'vue-property-decorator'
import { namespace } from 'vuex-class'

import BaseList from '@/components/BaseList'

const lessonsModule = namespace('lessons')

@Component()
export default class StudentLessonList extends BaseList {
  @lessonsModule.State('statuses') stateStatuses

  @Prop({
    type: Object,
    required: true,
    default: () => {}
  })
  filter

  title = false

  columns = [
    {
      label: 'ID',
      field: '_id',
      hidden: true
    },
    {
      label: 'Subject',
      field: 'subject.name'
    },
    {
      label: 'Total Minutes',
      field: 'scheduledMins',
      type: 'number'
    },
    // {
    //   label: 'Tutor',
    //   field: rowObj =>
    //      `${rowObj.tutor.student.firstName} ${rowObj.tutor.student.lastName}`
    // },
    {
      label: 'Tutor',
      field: rowObj => 
      {
        const firstName = rowObj.tutor && rowObj.tutor.student ? rowObj.tutor.student.firstName : '';
        const lastName = rowObj.tutor && rowObj.tutor.student ? rowObj.tutor.student.lastName : '';
        return `${firstName} ${lastName}`;
      }
    },
    {
      label: 'Schedule Date',
      field: 'scheduledDate',
      type: 'date',
      dateInputFormat: 'YYYY-MM-DDThh:mm', // expects 2018-03-16
      dateOutputFormat: 'M/D/YYYY hh:mma'
    },
    {
      label: 'Status',
      field: 'status'
    },
    {
      label: 'Actions',
      field: 'actions'
    }
  ]

  schema = null

  @Watch('stateStatuses', { immediate: true })
  onWatchStateStatuses() {
    this.columns.find(item => item.field === 'status').field = rowObj => {
      return this.stateStatuses && this.stateStatuses[rowObj.status]
    }
  }

  get defaultServerParams() {
    return {
      _fields:
        'status,scheduledMins,scheduledDate,requestedDate,approvedDate,realMins,extendedMins,student.firstName,student.lastName,tutor.student.firstName,tutor.student.lastName,rate',
      ...this.filter
    }
  }

  modalLessonDetail(item) {
    return {
      modalTitle: 'Lesson Detail',
      component: () => import('@/components/students/_LessonDetail'),
      componentProps: {
        item,
        statusOptions: this.stateStatuses
      }
    }
  }
}
</script>

<style scoped></style>



// WEBPACK FOOTER //
// src/components/students/_StudentLessonList.vue